import { type ClassValue, clsx } from 'clsx'
import { createHash } from 'crypto'
import { twMerge } from 'tailwind-merge'

import { BASE_URL, LOCALES } from '../constants'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateAlternates(path: string, locale: string = 'hy') {
  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`
  const normalizedPath = withLeadingSlash === '/' ? '' : withLeadingSlash

  return {
    languages: {
      ...Object.fromEntries(
        LOCALES.map((loc) => [loc, `${BASE_URL}/${loc}${normalizedPath}`])
      ),
      'x-default': `${BASE_URL}/hy${normalizedPath}`
    },
    canonical: `${BASE_URL}/${locale}${normalizedPath}`,
    default: `${BASE_URL}${normalizedPath}`
  }
}

export function generateId(href: string, label: string): string {
  return createHash('md5')
    .update(`${href}-${label}`)
    .digest('hex')
    .substring(0, 8)
}

export function isAfterDateTime(target: Date): boolean {
  return new Date() > target
}

export function isAfterDecember31UTC(): boolean {
  const now = new Date()

  const dec31EndUTC = new Date(Date.UTC(2025, 11, 31, 23, 59, 59, 999))

  return now.getTime() > dec31EndUTC.getTime()
}
